import React, { useContext } from "react";
import Logo from "../../../assets/images/clsm-logo.svg";
import "./forgotPassword.css";
import { ForgotPasswordContext } from "../ForgotPasswordView";
import ThemeButton from "../../../components/ThemeButton/ThemeButton";
import ThemeInput from "../../../components/ThemeInput/ThemeInput";
import PopupAlertError from "../../../components/PopupAlertError/PopupAlertError";
import SuccessPopupAlert from "../../../components/PopupAlertSuccess/PopupAlert";
import Loader from "../../../components/Loader/Loader";

const ForgotPasswordPage = () => {
  const {
    pageContent,
    navigatepage,
    email,
    handleEmailChange,
    setErrorAlertShow,
    errorAlertMessage,
    errorAlertShow,
    setSuccessAlertShow,
    successAlertMessage,
    successAlertShow,
    forgotPasswordSubmit,
    validateEmailMsg,
    spinnerStatus,
    buttonText,
    statusValue,
    handleEmailBlur,
  } = useContext(ForgotPasswordContext);

  return (
    <div className="forgotPasswordPage">
      {spinnerStatus && <Loader />}
      <div className="forgotPasswordSection">
        <div className="passwordLeft"></div>
      </div>
      <div className="forgotPasswordEnter">
        <div className="flexContentData">
          <h3>
            <img src={Logo} alt="logo" />
          </h3>
          <p className="mb-0 form-title">{pageContent.forgotPasswordTitle}</p>
          <p className="forgot-text mt-3">{pageContent.forgotNote}</p>

          {/* Form starts */}
          <form onSubmit={forgotPasswordSubmit}>
            <label className="input-label mt-3 mb-1">
              {pageContent.forgotEmailLabel}
            </label>
            <ThemeInput
              placeholder={pageContent.forgotEmailPlaceholder}
              value={email}
              onChange={handleEmailChange}
              onBlur={handleEmailBlur}
            />
            <p className="mb-0 error-msg">
              {validateEmailMsg ? validateEmailMsg : ""}
            </p>
            <ThemeButton
              value={pageContent.forgotButtonText}
              className="mt-4"
              type="submit"
              id={"forgotPasswordsubmitbtns"}
            />
            <div className="back-login mt-5" onClick={navigatepage}>
              {pageContent.backToLogin}
            </div>
          </form>
        </div>
      </div>
      <PopupAlertError
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          setErrorAlertShow(false);
          if (statusValue === 401 || statusValue === 403) {
            // goToLogin();
            setErrorAlertShow(false);
          } else {
            setErrorAlertShow(false);
            document.getElementById("forgotPasswordsubmitbtns").click();
          }
        }}
      />
      <SuccessPopupAlert
        show={successAlertShow}
        alertMessage={successAlertMessage}
        handleSubmit={navigatepage}
      />
    </div>
  );
};

export default ForgotPasswordPage;
